import React from 'react';
import { Button, Stack } from '@mui/material';

import { useCalendar } from '../../api';

interface Props {
  selectedIds: string[];
}

export const BulkActions = ({ selectedIds }: Props) => {
  const { handleCompleteEvent, handleReDateEvent, handleRePrioritizeEvent } = useCalendar();

  return (
    <Stack direction="row" gap="1rem">
      <Button size="small" variant="text" onClick={() => handleReDateEvent(selectedIds)}>
        Re-date
      </Button>

      <Button size="small" variant="text" onClick={() => handleRePrioritizeEvent(selectedIds)}>
        Priority
      </Button>

      <Button size="small" variant="text" onClick={() => handleCompleteEvent(selectedIds)}>
        Complete
      </Button>
    </Stack>
  );
};
